import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../../../primitives/object-id-schema';
import { LineItemProductSchema } from '../../../line-item-product';
import { LINE_ITEM_TYPES } from '../../line-item-type-schema';
import { BaseProductLineItemSchema } from '../base-product-line-item';
import { TiersUsageMapSchema } from './tiers-usage-map/tiers-usage-map-schema';

export const NewUsageLineItemSchema = BaseProductLineItemSchema.extend({
  type: oz.literal(LINE_ITEM_TYPES.Usage),
  invoiceId: ObjectIdSchema,
  units: oz.number().nonnegative(),
  tiersUsageMap: TiersUsageMapSchema,
  instanceUsageMap: TiersUsageMapSchema.optional(),
  lineItemProduct: LineItemProductSchema.required({ productId: true }),
}).openapi('NewUsageLineItem');

export type NewUsageLineItem = oz.infer<typeof NewUsageLineItemSchema>;